import { Link } from "react-router-dom";
import { ROUTES } from "../Routes";
import logo from '../assets/logoIcon.png';
import { useState } from "react";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const menuItems = [
    { label: 'Home', path: ROUTES.BASE },
    { label: 'Play', path: ROUTES.GAME },
    { label: 'Disclaimer', path: ROUTES.DISCLAIMER },
    { label: 'Terms', path: ROUTES.TERMS },
    { label: 'Privacy', path: ROUTES.PRIVACY },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to={ROUTES.BASE} className="logo">
          <img src={logo} alt="Xalro Logo" className="logo-icon" />
          <span className="logo-text">Xalro</span>
        </Link>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link to={item.path}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className={`mobile-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;